const mainFields = `
  id
  typeHandle
  idName
  backgroundFrames {
    url @transform(mode: "crop", width: 1440, height: 900, immediately: true)
    title
  }
`

const blockFields = `
  id
  typeHandle
  idName
  backgroundImage {
    url @transform(mode: "crop", width: 2000, immediately: true)
    title
    hasFocalPoint
    focalPoint
  }
  backgroundImageMobile {
    url @transform(mode: "crop", width: 640, immediately: true)
    title
    hasFocalPoint
    focalPoint
  }
  backgroundVideo {
    url
    title
    embeddedAsset {
      title
      url
      providerName
    }
  }
  backgroundVideoPoster {
    url @transform(mode: "crop", width: 2000, immediately: true)
    title
  }
  backgroundOpacity
  alignItems
  textAlign
  textColor
  typographyVariant
  heading
  copy
  additionalName
  additionalOccupation
  button {
    type
    url
    text
    target
  }
  buttonVariant
  scrollButton
  scrollButtonStyle
  mobileHeaderAtTop
`

export const CMastheadFragments = {
  field: `
    fragment masthead on masthead_MatrixField {
      ... on masthead_main_Entry {
        ${mainFields}
      }
      ... on masthead_block_Entry {
        ${blockFields}
      }
    }
  `,
  uiField: `
    fragment uiMasthead on uiMasthead_MatrixField {
      ... on uiMasthead_block_Entry {
        ${blockFields}
      }
    }
  `,
}
